import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
// eslint-disable-next-line unused-imports/no-unused-imports -- referenced by the props typedef
import LinkButton from '../LinkButton';

/**
 * @typedef {object} AnimatedWrapperOwnProps
 * @property {string|React.ElementType} [as]
 * @property {boolean} show
 */

/**
 * @typedef {AnimatedWrapperOwnProps &
 *   React.ComponentProps<'div'> &
 *   Partial<React.ComponentPropsWithoutRef<typeof LinkButton>>} AnimatedWrapperProps
 */

/**
 * @param {AnimatedWrapperProps} props
 */
const AnimatedWrapper = props => {
  const { children, as = 'div', show, ...otherProps } = props;

  const Component = useMemo(() => motion.create(as), [as]);

  if (!show) {
    return null;
  }

  return (
    <Component
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -20, opacity: 0 }}
      transition={{ duration: 0.2, delay: 0.1 }}
      {...otherProps}>
      {children}
    </Component>
  );
};

export default AnimatedWrapper;
